import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Ship } from "lucide-react";

function Loader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background ocean-bg">
      <div className="animate-pulse">
        <Ship className="h-12 w-12 text-[hsl(var(--gold))]" />
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, min }) {
  const { user, checked, hasRole } = useAuth();
  if (!checked || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (min && !hasRole(min)) return <Navigate to="/dashboard" replace />;
  return children;
}
